import { Waypoint } from 'react-waypoint';

import { Button } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { DmCards } from './components/DmCards/index_new';
import { DmOverview } from './components/DmOverview/index_new';
import { useDecisionMakersList } from './hooks/useDecisionMakersList';

export function DecisionMakersListReskin(): React.JSX.Element | null {
	const {
		data: { petitionEditPage, dmSources, decisionMakers, shouldDisplayDecisionMakersList },
		actions: { trackAddOrEditDmsClick, trackView },
	} = useDecisionMakersList();

	if (!shouldDisplayDecisionMakersList) return null;
	const decisionMakersAvailable = decisionMakers.length > 0;

	return (
		<div data-testid="mock-decision-makers-list" className="bg-white">
			<Waypoint onEnter={() => trackView()} />

			<div className="flex h-full flex-col gap-6 p-4 py-8 md:p-12 md:pt-8 lg:py-12">
				<DmOverview dmSources={dmSources} />

				<DmCards />

				<div
					className={cn('flex', { 'flex-row-reverse': decisionMakersAvailable, 'flex-row': !decisionMakersAvailable })}
				>
					<Button
						as="a"
						data-qa="edit-decision-makers-button"
						variant={decisionMakersAvailable ? 'secondary' : 'primary'}
						href={petitionEditPage}
						onClick={trackAddOrEditDmsClick}
						size="small"
						className="w-full md:w-auto"
					>
						{decisionMakersAvailable ? 'Edit decision makers' : 'Add decision makers'}
					</Button>
				</div>
			</div>
		</div>
	);
}
